import { useState } from 'react';
import { Link } from 'react-router-dom';
import CartButton from '../../components/feature/CartButton';

export default function AboutPage() {
  const [isScrolled, setIsScrolled] = useState(false);

  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', () => {
      setIsScrolled(window.scrollY > 50);
    });
  }

  return (
    <div className="min-h-screen bg-white">
      {/* 네비게이션 */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white'}`}>
        <div className="max-w-7xl mx-auto px-8 py-6 flex items-center justify-between">
          <div className="flex items-center gap-12">
            <Link to="/">
              <img src="https://static.readdy.ai/image/f77122aa20e12351d50b895437d7646f/26f7e4287336b6a14c4caa48b3ce1ec3.png" alt="초이담 참새한과" className="h-12 w-auto cursor-pointer" />
            </Link>
            <div className="hidden md:flex items-center gap-8">
              <Link to="/" className="text-sm font-medium text-gray-900 hover:text-amber-700 transition-colors cursor-pointer">홈</Link>
              <Link to="/about" className="text-sm font-medium text-amber-700 transition-colors cursor-pointer">브랜드 소개</Link>
              <a href="/#custom-gifts" className="text-sm font-medium text-gray-900 hover:text-amber-700 transition-colors cursor-pointer">맞춤 선물</a>
              <a href="/#menu" className="text-sm font-medium text-gray-900 hover:text-amber-700 transition-colors cursor-pointer">메뉴</a>
              <a href="/#testimonials" className="text-sm font-medium text-gray-900 hover:text-amber-700 transition-colors cursor-pointer">고객 후기</a>
              <a href="/#contact" className="text-sm font-medium text-gray-900 hover:text-amber-700 transition-colors cursor-pointer">문의</a>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <CartButton isScrolled={true} />
            <Link to="/custom-order">
              <button className="px-6 py-2.5 bg-gray-900 text-white rounded-full text-sm font-medium hover:bg-gray-800 transition-all whitespace-nowrap cursor-pointer">
                주문하기
              </button>
            </Link>
          </div>
        </div>
      </nav>

      {/* 히어로 섹션 */}
      <section className="relative pt-32 pb-20 overflow-hidden" style={{ background: 'linear-gradient(180deg, #8B6F47 0%, #5D4E37 100%)' }}>
        <div className="absolute inset-0 opacity-5" style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'1\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")' }}></div>
        
        <div className="max-w-7xl mx-auto px-8 relative z-10">
          <div className="mb-6">
            <span className="inline-block bg-pink-200/30 backdrop-blur-sm px-4 py-2 rounded text-sm text-pink-100 font-medium">/ 우리의 이야기</span>
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: "'Noto Serif KR', serif" }}>
            전통의 맛을 지키며 현대의 감각을 담다
          </h1>
          <p className="text-base md:text-lg text-amber-100/90 leading-relaxed max-w-3xl">
            초이담 참새한과는 1987년부터 이어온 한과 장인의 손길로<br />
            우리 고유의 맛과 멋을 지켜왔습니다.
          </p>
        </div>
      </section>

      {/* 역사 섹션 */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-8">
          <div className="grid md:grid-cols-2 gap-16 items-center mb-24">
            <div>
              <div className="text-7xl md:text-8xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>1987</div>
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Noto Serif KR', serif" }}>
                한과 장인의<br />첫 걸음
              </h2>
              <p className="text-base text-gray-600 leading-relaxed mb-6">
                1987년, 한과에 대한 열정 하나로 시작한 작은 공방에서 초이담의 역사가 시작되었습니다. 
                전통 방식을 고수하며 정성스럽게 만든 한과는 입소문을 타고 많은 분들께 사랑받기 시작했습니다.
              </p>
              <p className="text-base text-gray-600 leading-relaxed">
                35년이 넘는 시간 동안 변하지 않는 것은 좋은 재료와 정성스러운 손길입니다. 
                매일 아침 신선한 재료를 준비하고, 하나하나 정성을 다해 만드는 우리의 마음은 
                처음 그날과 다르지 않습니다.
              </p>
            </div>
            <div className="bg-amber-50 rounded-3xl overflow-hidden aspect-square">
              <img 
                src="https://public.readdy.ai/ai/img_res/7a828e7eaad629c717b5665d9fea7c73.jpg" 
                alt="초이담의 시작" 
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* 타임라인 */}
          <div className="relative">
            <div className="absolute left-1/2 transform -translate-x-1/2 w-0.5 h-full bg-amber-200"></div>
            
            <div className="space-y-20">
              {/* 1987 */}
              <div className="relative grid md:grid-cols-2 gap-8 items-center">
                <div className="text-right">
                  <div className="inline-block bg-amber-100 px-5 py-1.5 rounded-full text-amber-900 font-bold text-sm mb-3">1987</div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">초이담 창업</h3>
                  <p className="text-sm text-gray-600">전통 한과 제조 시작</p>
                </div>
                <div></div>
                <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-4 h-4 bg-amber-700 rounded-full border-4 border-white"></div>
              </div>

              {/* 1995 */}
              <div className="relative grid md:grid-cols-2 gap-8 items-center">
                <div></div>
                <div>
                  <div className="inline-block bg-amber-100 px-5 py-1.5 rounded-full text-amber-900 font-bold text-sm mb-3">1995</div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">공방 확장</h3>
                  <p className="text-sm text-gray-600">생산 시설 확대 및 직원 채용</p>
                </div>
                <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-4 h-4 bg-amber-700 rounded-full border-4 border-white"></div>
              </div>

              {/* 2005 */}
              <div className="relative grid md:grid-cols-2 gap-8 items-center">
                <div className="text-right">
                  <div className="inline-block bg-amber-100 px-5 py-1.5 rounded-full text-amber-900 font-bold text-sm mb-3">2005</div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">전통식품 인증</h3>
                  <p className="text-sm text-gray-600">우수 전통식품 품질 인증 획득</p>
                </div>
                <div></div>
                <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-4 h-4 bg-amber-700 rounded-full border-4 border-white"></div>
              </div>

              {/* 2015 */}
              <div className="relative grid md:grid-cols-2 gap-8 items-center">
                <div></div>
                <div>
                  <div className="inline-block bg-amber-100 px-5 py-1.5 rounded-full text-amber-900 font-bold text-sm mb-3">2015</div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">온라인 주문 시작</h3>
                  <p className="text-sm text-gray-600">전국 배송 서비스 개시</p>
                </div>
                <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-4 h-4 bg-amber-700 rounded-full border-4 border-white"></div>
              </div>

              {/* 2024 */}
              <div className="relative grid md:grid-cols-2 gap-8 items-center">
                <div className="text-right">
                  <div className="inline-block bg-amber-100 px-5 py-1.5 rounded-full text-amber-900 font-bold text-sm mb-3">2024</div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">맞춤 선물 서비스</h3>
                  <p className="text-sm text-gray-600">주문 제작 시스템 도입</p>
                </div>
                <div></div>
                <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-4 h-4 bg-amber-700 rounded-full border-4 border-white"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 철학 섹션 */}
      <section className="py-24 bg-gradient-to-b from-amber-50/50 to-white">
        <div className="max-w-7xl mx-auto px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 leading-tight" style={{ fontFamily: "'Noto Serif KR', serif" }}>
              초이담의 철학
            </h2>
            <p className="text-base text-gray-600">우리가 지키는 세 가지 약속</p>
          </div>

          <div className="grid md:grid-cols-3 gap-10">
            {/* 철학 1 */}
            <div className="text-center">
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-5">
                <i className="ri-hand-heart-line text-amber-900 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: "'Noto Serif KR', serif" }}>정성</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                하나하나 손으로 빚어내는 정성스러운 마음으로 
                최고의 한과를 만듭니다. 기계가 아닌 사람의 손길이 
                만들어내는 특별함을 전합니다.
              </p>
            </div>

            {/* 철학 2 */}
            <div className="text-center">
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-5">
                <i className="ri-leaf-line text-amber-900 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: "'Noto Serif KR', serif" }}>신선함</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                주문 제작 방식으로 당일 제조하여 
                가장 신선한 상태로 전달합니다. 
                갓 만든 한과의 맛과 향을 그대로 느끼실 수 있습니다.
              </p>
            </div>

            {/* 철학 3 */}
            <div className="text-center">
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-5">
                <i className="ri-shield-check-line text-amber-900 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: "'Noto Serif KR', serif" }}>품질</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                엄선된 국산 재료만을 사용하며 
                첨가물을 최소화합니다. 
                건강하고 안전한 한과를 약속드립니다.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 제조 과정 섹션 */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-8">
          <div className="mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 leading-tight" style={{ fontFamily: "'Noto Serif KR', serif" }}>
              정성스러운<br />제조 과정
            </h2>
            <p className="text-base text-gray-600">전통 방식 그대로, 하나하나 손으로 만듭니다</p>
          </div>

          <div className="grid md:grid-cols-2 gap-12">
            {/* 과정 1 */}
            <div className="flex gap-5">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-amber-700 rounded-full flex items-center justify-center text-white text-lg font-bold">1</div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">재료 선별</h3>
                <p className="text-sm text-gray-600 leading-relaxed mb-5">
                  매일 아침 신선한 국산 재료를 엄선합니다. 
                  찹쌀, 꿀, 참기름 등 모든 재료는 
                  최상급 품질만을 사용합니다.
                </p>
                <div className="bg-amber-50 rounded-2xl overflow-hidden aspect-video">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Premium%20Korean%20ingredients%20for%20traditional%20confectionery%20carefully%20selected%2C%20rice%20flour%20honey%20sesame%20oil%20arranged%20on%20wooden%20table%2C%20natural%20organic%20materials%2C%20warm%20studio%20lighting%2C%20cream%20background%2C%20professional%20food%20photography%2C%20high%20quality%20ingredients%20display&width=800&height=600&seq=about-process-001&orientation=landscape" 
                    alt="재료 선별" 
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>

            {/* 과정 2 */}
            <div className="flex gap-5">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-amber-700 rounded-full flex items-center justify-center text-white text-lg font-bold">2</div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">반죽 준비</h3>
                <p className="text-sm text-gray-600 leading-relaxed mb-5">
                  전통 방식 그대로 반죽을 준비합니다. 
                  온도와 습도를 세심하게 조절하며 
                  최적의 상태를 만들어냅니다.
                </p>
                <div className="bg-pink-50 rounded-2xl overflow-hidden aspect-video">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Korean%20confectionery%20artisan%20preparing%20traditional%20dough%20by%20hand%2C%20kneading%20rice%20flour%20mixture%2C%20detailed%20close-up%20of%20hands%20working%2C%20warm%20studio%20lighting%2C%20cream%20background%2C%20professional%20craftsmanship%20photography%2C%20traditional%20food%20preparation%20process&width=800&height=600&seq=about-process-002&orientation=landscape" 
                    alt="반죽 준비" 
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>

            {/* 과정 3 */}
            <div className="flex gap-5">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-amber-700 rounded-full flex items-center justify-center text-white text-lg font-bold">3</div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">성형 및 조리</h3>
                <p className="text-sm text-gray-600 leading-relaxed mb-5">
                  장인의 손길로 하나하나 모양을 빚고 
                  적절한 온도에서 조리합니다. 
                  오랜 경험으로 완성된 기술입니다.
                </p>
                <div className="bg-green-50 rounded-2xl overflow-hidden aspect-video">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Korean%20confectionery%20artisan%20shaping%20and%20frying%20traditional%20hangwa%2C%20hands%20carefully%20forming%20yakgwa%20cookies%2C%20cooking%20process%20in%20traditional%20oil%2C%20warm%20studio%20lighting%2C%20cream%20background%2C%20professional%20craftsmanship%20photography%2C%20detailed%20food%20preparation&width=800&height=600&seq=about-process-003&orientation=landscape" 
                    alt="성형 및 조리" 
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>

            {/* 과정 4 */}
            <div className="flex gap-5">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-amber-700 rounded-full flex items-center justify-center text-white text-lg font-bold">4</div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">마무리 및 포장</h3>
                <p className="text-sm text-gray-600 leading-relaxed mb-5">
                  완성된 한과를 정성스럽게 포장합니다. 
                  선물하기 좋은 고급스러운 패키지로 
                  마음까지 전달합니다.
                </p>
                <div className="bg-rose-50 rounded-2xl overflow-hidden aspect-video">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Elegant%20Korean%20traditional%20confectionery%20gift%20packaging%20process%2C%20artisan%20hands%20carefully%20wrapping%20hangwa%20in%20beautiful%20box%2C%20luxurious%20presentation%2C%20warm%20studio%20lighting%2C%20cream%20background%2C%20professional%20product%20photography%2C%20premium%20gift%20wrapping&width=800&height=600&seq=about-process-004&orientation=landscape" 
                    alt="마무리 및 포장" 
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA 섹션 */}
      <section className="py-24 bg-gradient-to-b from-white to-amber-50/30">
        <div className="max-w-4xl mx-auto px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 leading-tight" style={{ fontFamily: "'Noto Serif KR', serif" }}>
            초이담의 한과를<br />경험해보세요
          </h2>
          <p className="text-base text-gray-600 mb-10 leading-relaxed">
            35년 전통의 맛과 정성을 담은 한과를 만나보세요
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/#menu">
              <button className="px-7 py-3 bg-gray-900 text-white rounded-full text-sm font-medium hover:bg-gray-800 transition-all whitespace-nowrap cursor-pointer">
                메뉴 둘러보기
              </button>
            </Link>
            <Link to="/custom-order">
              <button className="px-7 py-3 bg-white text-gray-900 border-2 border-gray-900 rounded-full text-sm font-medium hover:bg-gray-50 transition-all whitespace-nowrap cursor-pointer">
                맞춤 선물 주문하기
              </button>
            </Link>
          </div>
        </div>
      </section>

      {/* 푸터 */}
      <footer className="bg-gradient-to-b from-amber-900 to-amber-950 text-white mx-5 mb-5 rounded-t-3xl">
        <div className="max-w-7xl mx-auto px-12 py-14">
          <div className="grid md:grid-cols-4 gap-10 mb-10">
            <div className="md:col-span-1">
              <h3 className="text-2xl font-bold leading-tight mb-5" style={{ fontFamily: "'Noto Serif KR', serif" }}>
                초이담과 함께<br />특별한 선물을
              </h3>
            </div>

            <div>
              <h4 className="font-medium text-white text-sm mb-5">메뉴</h4>
              <ul className="space-y-3 text-amber-100 text-sm">
                <li><Link to="/" className="hover:text-white transition-colors cursor-pointer">홈</Link></li>
                <li><Link to="/about" className="hover:text-white transition-colors cursor-pointer">브랜드 소개</Link></li>
                <li><Link to="/custom-order" className="hover:text-white transition-colors cursor-pointer">맞춤 선물</Link></li>
                <li><a href="/#menu" className="hover:text-white transition-colors cursor-pointer">메뉴</a></li>
                <li><a href="/#contact" className="hover:text-white transition-colors cursor-pointer">오시는 길</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-medium text-white text-sm mb-5">소셜 미디어</h4>
              <ul className="space-y-3 text-amber-100 text-sm">
                <li className="flex items-center gap-3 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-base"></i>
                  <span>Instagram</span>
                </li>
                <li className="flex items-center gap-3 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-article-line text-base"></i>
                  <span>Blog</span>
                </li>
                <li className="flex items-center gap-3 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-chat-3-line text-base"></i>
                  <span>KakaoTalk</span>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-medium text-white text-sm mb-4">문의</h4>
              <ul className="space-y-2 text-amber-100 text-sm">
                <li>전화: 02-1234-5678</li>
                <li>이메일: info@choidam.com</li>
                <li>운영시간: 평일 09:00 - 18:00</li>
              </ul>
            </div>
          </div>

          <div className="relative pt-6 border-t border-amber-800">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-xs text-amber-200">© 2024 초이담 참새한과. All rights reserved.</p>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-xs text-amber-200 hover:text-white transition-colors cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
